import { getId, getType } from 'apis/model/base'
import _ from 'lodash'
import React, { useContext, useMemo } from 'react'
import { Responses } from 'views/Feed/Responses'
import FeedContext from '../FeedContext'
import { BestComment } from './AskContentLayout'
import {LayoutContext} from "../../layouts/Default/LayoutContext";
import {FeedActions} from "../FeedCard";

const AskFooter = () => {
  const { item } = useContext(FeedContext)
  const { isSm } = useContext(LayoutContext)

  const best_comment = _.get(item, 'best_comment', {})

  const feature = useMemo(
    () => () =>
      (
          <BestComment item={best_comment} />
      ),
    [best_comment]
  )

  if (_.isEmpty(item)) return null

  return (
      <div style={{ marginLeft: isSm && -30 }} className="flex flex-col gap-3">
          <FeedActions reportAccess={true}/>
          <div className="FeedCardFooter w-full mb-3 space-y-8">
              <Responses
                  id={getId(item)}
                  type={getType(item)}
                  Feature={feature}
              />
          </div>
      </div>
  )
}

export default AskFooter
